module.exports = __webpack_public_path__ + "img/lw-logo-temp.f561d2b2.png";